import UploadCloudIcon from "@redotech/redo-icons/upload-cloud-02.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoCollapseSubsection } from "@redotech/redo-web/arbiter-components/collapse/redo-collapse-section";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoProgressBar } from "@redotech/redo-web/arbiter-components/progress-bar/redo-progress-bar";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useZendeskConversationsImport } from "../use-zendesk-conversations-import";

export const ZendeskConversationsTab = memo(function ZendeskConversationsTab({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const {
    file,
    loading,
    progress,
    merchantEmail,
    setMerchantEmail,
    handleFileChange,
    handleSubmit,
  } = useZendeskConversationsImport({ teamId });

  return (
    <Flex dir="column" gap="md">
      <Text fontSize="sm" textColor="secondary">
        Upload a Zendesk conversations export (NDJSON format). Each line in the
        file should be a JSON object representing a Zendesk ticket with its
        comments.
      </Text>
      <RedoCollapseSubsection title="Instructions">
        <Flex dir="column" gap="sm" pl="lg">
          <Text fontSize="sm" textColor="secondary">
            To export your Zendesk conversations:
          </Text>
          <Text fontSize="sm" textColor="secondary">
            <li>• Go to Zendesk Admin Center → Account → Tools → Reports</li>
            <li>• Under "Export", select "JSON" format to export tickets</li>
            <li>
              • Download the exported file (each line is one ticket JSON object)
            </li>
            <li>• Upload the file here</li>
          </Text>
        </Flex>
      </RedoCollapseSubsection>
      <RedoTextInput
        label="Merchant email (optional — filters by recipient address)"
        placeholder="support@merchant.com"
        setValue={setMerchantEmail}
        size="sm"
        value={merchantEmail}
      />
      <Flex align="center" gap="md">
        <label htmlFor="zendesk-conversations-upload">
          <RedoButton
            disabled={loading}
            hierarchy="secondary"
            IconLeading={UploadCloudIcon}
            onClick={() =>
              document.getElementById("zendesk-conversations-upload")?.click()
            }
            size="md"
            text="Choose File"
            theme="normal"
          />
        </label>
        {/* design-allow: hidden native file picker, not a text input */}
        <input
          accept=".json,.ndjson"
          id="zendesk-conversations-upload"
          onChange={handleFileChange}
          // design-allow: hidden file input has no visible styling to express via tokens
          style={{ display: "none" }}
          type="file"
        />
        {file && (
          <Text fontSize="sm" textColor="secondary">
            {file.name}
          </Text>
        )}
      </Flex>
      <div>
        <RedoButton
          disabled={!file || loading}
          hierarchy="primary"
          IconLeading={UploadCloudIcon}
          onClick={handleSubmit}
          pending={loading}
          size="md"
          text="Import Conversations"
          theme="normal"
        />
      </div>
      {loading && (
        <RedoProgressBar
          labelOrientation="right"
          labelStyle="text"
          percentage={progress}
          style="thin"
        />
      )}
    </Flex>
  );
});
